export default __webpack_public_path__ + "static/media/potatoes.e138eb1c.png";